module.exports = __webpack_public_path__ + "static/media/doorbell-pressed.99514811.png";